exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hs-navigation-backward {\n  top: 50%;\n  left: 20px;\n  position: fixed; }\n", ""]);

// exports
